module.exports = __webpack_public_path__ + "static/media/2.2758400a.jpg";